import { render, staticRenderFns } from "./EditModelFormPage.vue?vue&type=template&id=59cbec24&scoped=true"
import script from "./EditModelFormPage.vue?vue&type=script&lang=ts"
export * from "./EditModelFormPage.vue?vue&type=script&lang=ts"
import style0 from "./EditModelFormPage.vue?vue&type=style&index=0&id=59cbec24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cbec24",
  null
  
)

export default component.exports